import {TileSelectionManager} from "./tile-selection-manager";

window.startTileManager = function() {
  const tileSelectionManager = new TileSelectionManager(
    // eslint-disable-next-line no-undef
    tileData,
    document.getElementById('tile-selection-root'),
    document.getElementById('widget-sample-tile-selection__element--add'),
    '.form-title input',
    '.form-article-number input',
    '.form-company input',
    '.form-factory input',
  );

  // Code below here adds a preselected tile by url hash
  const urlHash = window.location.hash.substring(1);
  const urlParams = new URLSearchParams(urlHash);

  if (urlParams.has('tile')) {
    const tile = getTileById(urlParams.get('tile'));
    if (tile) {
      tileSelectionManager._addTileSelection();

      const tileSelectionComponent = tileSelectionManager.tileSelectionComponents[0];
      tileSelectionComponent.setProductSelection(tile.term_ziegel_kategorie.slug, tile.post_name);

      if (urlParams.has('color')) {
        const surface = getSurfaceById(tile, urlParams.get('color'));
        if (surface) {
          tileSelectionComponent.setSurfaceSelection(surface);
        }
      }
    }
  }

  /**
   * @param {string} id
   * @return {Tile}
   */
  function getTileById(id) {
    // eslint-disable-next-line no-undef
    const allTiles = Object.assign({}, ...Object.values(tileData.ziegel));
    return allTiles[id];
  }

  /**
   * @param {Tile} tile
   * @param {string} id
   * @return {Surface}
   */
  function getSurfaceById(tile, id) {
    const allSurfaces = Object.assign({}, ...Object.values(tile.child));
    return allSurfaces[id];
  }
};

